module.exports = __webpack_public_path__ + "img/8_31.9a9bd128.png";